export default {
  name: {
    id: 'rm_metal_platinum_name',
    defaultMessage: 'Platinum',
  },
  smartphoneLabel: {
    id: 'rm_metal_platinum_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_platinum_what_it_does',
    defaultMessage:
      "Platinum sits among the tiny amounts of precious metals detected in a phone's main circuit board. It is used in electronic devices because it resists corrosion and remains stable at high temperatures.",
  },
  extractionText1: {
    id: 'rm_metal_platinum_extraction_p1',
    defaultMessage:
      'Platinum is one of the six platinum-group metals (PGMs), alongside palladium, iridium, osmium, rhodium and ruthenium. It is usually mined alongside other PGMs rather than extracted on its own. The ore is crushed and ground, then mixed with water so that metal-bearing particles can be separated by flotation. The resulting concentrate is smelted into a mixture containing nickel, copper and other PGMs. Chemical processing then removes the base metals and separates the individual precious metals.',
  },
  quickFactText: {
    id: 'rm_metal_platinum_quick_fact',
    defaultMessage:
      'Producing 1 kg of platinum-group metals in South Africa can use up to 600,000 litres of water, emit up to 80 tonnes of CO₂ equivalent and require around 8 to 24 square metres of land.',
  },
  envSummaryText: {
    id: 'rm_metal_platinum_env_summary',
    defaultMessage:
      'Platinum has one of the heaviest environmental footprints of any metal. Its ore holds so little metal that vast amounts of rock must be mined and processed, and the electricity this demands, on a grid running mainly on coal, is by itself the biggest source of harm. Around the mines, soils and rivers also end up carrying far more platinum and other metals than untouched land.',
  },
  envWaterText: {
    id: 'rm_metal_platinum_env_water_text',
    defaultMessage:
      'Producing 1 kg of platinum-group metals in South Africa can require around 200,000 to 600,000 litres of water before the metal is concentrated. Up to 73% of this water can be lost through evaporation or seepage from mining-waste storage. Sulphur-rich waste can also make mine water acidic, threatening rivers and groundwater.',
  },
  envSoilText: {
    id: 'rm_metal_platinum_env_soil_text',
    defaultMessage:
      'The industry produces large volumes of waste that must be stored above ground. In Russia and Canada, sulphur-rich waste can react with air and water, creating acidic drainage that contaminates land and waterways.',
  },
  envBiodiversityText: {
    id: 'rm_metal_platinum_env_biodiversity_text',
    defaultMessage:
      'Underground mining disturbs less land than open-pit mining, but shafts, processing plants and waste-storage sites still transform landscapes. South African platinum-group operations use around 8 to 24 square metres of land per kilogram of metal. Some operations are close to protected areas, making dust, noise, water pollution and mine expansion a concern for nearby habitats.',
  },
  envClimateText: {
    id: 'rm_metal_platinum_env_climate_text',
    defaultMessage:
      'Producing 1 kg of platinum-group metals in South Africa releases around 25 to 80 tonnes of CO₂ equivalent, partly because the sector relies heavily on coal-powered electricity. The low concentration of the ore and the energy needed for crushing, concentration, smelting and refining add to the footprint.',
  },
  humanSummaryText: {
    id: 'rm_metal_platinum_human_summary',
    defaultMessage:
      'Platinum is produced in large industrial mines rather than small informal operations. In South Africa, the platinum-group metals sector employed around 175,000 people directly in 2017 and was one of the country’s most valuable mining sectors. However, the industry has a history of fatal accidents and long wage disputes, including a 150-day strike in 2014.',
  },
  humanHealthText: {
    id: 'rm_metal_platinum_human_health_text',
    defaultMessage:
      'Underground dust once caused many cases of silicosis, a permanent lung disease. Improved safety measures have made it less common. Mining deaths in South Africa also fell from more than 700 per year in the late 1980s to fewer than 100 in recent years. In 2020, 16 of the country’s 60 mining deaths occurred in platinum-group mines.',
  },
  humanLegalText: {
    id: 'rm_metal_platinum_human_legal_text',
    defaultMessage:
      'In 2012, police killed 34 striking miners at Marikana, a platinum mine in South Africa. Human rights organisations later criticised the companies buying from the mine, including carmakers and chemical producers, for failing to take responsibility for abuses in their supply chain. The mine was not directly covered by the main responsible-sourcing certification, and industry guidance was only a minimum standard.',
  },
  geoSummaryText: {
    id: 'rm_metal_platinum_geo_summary',
    defaultMessage:
      'South Africa, Zimbabwe and Russia supplied around 92% of mined platinum in 2024. South Africa alone produced around 71%. This concentration exposes global supply to political decisions, export restrictions, power shortages, labour disputes and operational disruptions in a small number of countries.',
  },
  geoDugText: {
    id: 'rm_metal_platinum_geo_dug_text',
    defaultMessage:
      'Platinum deposits are usually found in large underground rock formations created by ancient volcanic activity. The main producing countries are South Africa, Zimbabwe, Russia, Canada and the United States. The largest deposits are in South Africa’s Bushveld Complex and Zimbabwe’s Great Dyke.',
  },
  geoProcessedText: {
    id: 'rm_metal_platinum_geo_processed_text',
    defaultMessage:
      'Platinum is typically concentrated, smelted and refined near the main mining areas. South Africa accounts for roughly 71% to 74% of global platinum output.',
  },
  geoLeverageText: {
    id: 'rm_metal_platinum_geo_leverage_text',
    defaultMessage:
      'Some export controls exist, although they are limited. South Africa, Russia and Zimbabwe have all introduced trade measures affecting platinum. Russia and South Africa imposed non-automatic export-licensing requirements, while Zimbabwe applied an export tax. After Russia invaded Ukraine, sanctions and customer decisions made access to some markets less certain for Russian metal. Norilsk’s membership in the Initiative for Responsible Mining Assurance (IRMA) was also suspended.',
  },
  supplySummaryText: {
    id: 'rm_metal_platinum_supply_summary',
    defaultMessage:
      'Supply can broadly keep up with demand, but it has limited flexibility. Large group-level reserves and established recycling reduce the risk of short-term depletion. However, production is concentrated in a few countries, and platinum is mined with other metals, so supply cannot be increased quickly after a disruption.',
  },
  supplyReservesText: {
    id: 'rm_metal_platinum_supply_reserves_text',
    defaultMessage:
      'Reserves are large but highly concentrated. Global platinum-group metal reserves are estimated at about 70,000 tonnes, with nearly 89% located in South Africa. Geological availability is therefore less of a concern than dependence on a single country.',
  },
  supplyDemandText: {
    id: 'rm_metal_platinum_supply_demand_text',
    defaultMessage:
      'Platinum demand is more diversified than palladium demand. In 2022, around 41% went to vehicle catalysts, 20% to jewellery, 10% to the chemical industry, 9% to glass production and 3% to electricity and electronics. Automotive demand is expected to decline as electric vehicles become more common, while industrial, glass and hydrogen-related uses may grow.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_platinum_recycling_summary',
    defaultMessage:
      'Platinum is recovered mainly from spent car catalytic converters, and to a smaller and shrinking degree from electronics. As electric vehicles replace combustion engines, the main recovery stream is getting smaller, and recycled material still covers only a limited share of total demand.',
  },
  recyclingInputText: {
    id: 'rm_metal_platinum_recycling_input_text',
    defaultMessage:
      'Recycling from electronic equipment is declining. Platinum is still recovered, but in smaller quantities, as it is increasingly replaced by palladium in electronic devices. In Europe, the end-of-life recycling input rate for all platinum-group metals is between 11% and 14%.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_platinum_recycling_outlook_text',
    defaultMessage:
      'Recovery remains viable and active at industrial scale, particularly from automotive catalysts. Recovered platinum is reused in catalytic applications and hydrogen technologies. However, the European end-of-life recycling input rate for all platinum-group metals remains between 11% and 14%. This rate is limited by declining platinum content in electronics and the gradual decline of the catalytic-converter stream.',
  },
  mine0Region: {
    id: 'rm_metal_platinum_mine0_region',
    defaultMessage: 'Bushveld Complex, Rustenburg district',
  },
  mine1Region: {
    id: 'rm_metal_platinum_mine1_region',
    defaultMessage: 'Norilsk',
  },
  mine2Region: {
    id: 'rm_metal_platinum_mine2_region',
    defaultMessage: 'Great Dyke',
  },
} as const
